import { TimeOffCategoryPolicySchema } from "@/pages/settings/time-off/policy/TimeOffCategoryPolicyEdit.tsx";
import { Box, Radio, Stack, Title } from "@skailer-com/uikit";
import { Controller, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

export interface TimeOffPolicyRequireConfirmationProps {
  formHook: UseFormReturn<TimeOffCategoryPolicySchema>;
}

export function TimeOffPolicyRequireConfirmation({
  formHook,
}: TimeOffPolicyRequireConfirmationProps) {
  const { t } = useTranslation();
  const { control } = formHook;

  return (
    <Stack>
      <Title
        header={t("time_off:require_confirmation")}
        caption={t("time_off:require_confirmation_description")}
        size={"xs"}
        paddingBottom
      />
      <Box variant={"border"}>
        <Controller
          render={({ field: { value, onChange } }) => (
            <>
              <Radio
                value={"true"}
                checked={value == true}
                onChange={() => {
                  onChange(true);
                }}
                title={t("time_off:require_confirmation_yes_caption")}
                caption={t("time_off:require_confirmation_yes_description")}
              />
              <Radio
                value={"false"}
                checked={value == false}
                onChange={() => {
                  onChange(false);
                }}
                title={t("time_off:require_confirmation_no_caption")}
                caption={t("time_off:require_confirmation_no_description")}
              />
            </>
          )}
          control={control}
          name={"accrual_confirm_required"}
        />
      </Box>
    </Stack>
  );
}
